import { Injectable } from '@angular/core';
import type { ChildrenFilterState } from '../types';

const INITIAL_CHILDREN_FILTER_STATE: ChildrenFilterState = {
  search: '',
  location: null,
  group: null,
  hidden: null,
  sortField: null,
  sortDirection: 'asc',
  page: 0,
};

/**
 * Holds the Child Overview list state (search, scope filters, sort, page) in memory for the
 * session so it survives leaving the page and returning. Root-scoped, so it outlives the page
 * across navigation; a full reload re-creates it and the state resets.
 */
@Injectable({ providedIn: 'root' })
export class ChildrenFilterStore {
  private state: ChildrenFilterState = INITIAL_CHILDREN_FILTER_STATE;

  get snapshot(): ChildrenFilterState {
    return this.state;
  }

  save(state: ChildrenFilterState): void {
    this.state = state;
  }
}
